import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconGooglePlayStyle0 = gravityIconIndividualCss;

const GravityIconGooglePlay = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ffa94d46d751a190a9c6727ff52b0c1601c2b187', color: this.color, size: this.size }, h("svg", { key: '3d67547ed46afe2aad6d8fc3f7eb1fc85e966a9f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '899a0c84803eb6975d60e78890881fa72c4d227f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.417 18.438c-.257-.072-.425-.334-.425-.74V4.284c0-.376.142-.63.367-.723l6.42 7.475-6.362 7.4Zm.884-.285 7.726-4.497-1.881-2.19L6.3 18.152Zm7.78-9.795L6.462 3.924l5.695 6.673 1.924-2.239Zm.516.301 2.985 1.737c.565.33.57.86 0 1.192l-3.06 1.78-1.996-2.338 2.071-2.37Z", fill: "currentColor" }))));
    }
};
GravityIconGooglePlay.style = GravityIconGooglePlayStyle0;

export { GravityIconGooglePlay as gravity_icon_google_play };

//# sourceMappingURL=gravity-icon-google-play.entry.js.map